/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const check = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M18.3 5.6L9.9 16.9l-4.6-3.4-.9 1.2 5.8 4.3 9.3-12.6z" />
	</SVG>
);

export default check;
